/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_SendInputs */

const en_features_plan_send = /** @type {(inputs: Features_Plan_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send plan`)
};

const pl_features_plan_send = /** @type {(inputs: Features_Plan_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij plan`)
};

/**
* | output |
* | --- |
* | "Send plan" |
*
* @param {Features_Plan_SendInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_send = /** @type {((inputs?: Features_Plan_SendInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_SendInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_send(inputs)
	return en_features_plan_send(inputs)
});